/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import MainLayout from 'components/layouts/main'
import {
  deleteDuplicateFPHistory,
  getDegodsFields,
  getDuplicateMagicEdenSlugs,
  getLastUpdatedList,
  getLastUpdatedListings,
  getMissingHyperspaceSlugsList,
  getSolListingsLastUpdated,
  getTestList,
  setCollectionInactive,
  setCollectionInactiveDuplicateMeSlugs,
} from 'services'
import Button from 'components/commons/button'
import { notifySuccess } from 'components/commons/toast'
import { toast, ToastContainer } from 'react-toastify'
import Chip from 'components/commons/chip'

const LastUpdatedListingsPage = () => {
  const [lastUpdatedList, setLastUpdatedList] = useState<any>([])
  const [limit, setLimit] = useState<number>(10)

  const [searchField, setSearchField] = useState<string>('')
  // const [chain, setChain] = useState<string>('solana')
  const [orderBy, setOrderBy] = useState<string>('stats.market_cap')

  useEffect(() => {
    getFields()
  }, [])

  useEffect(() => {
    setSearchField('')
    getFields()
  }, [limit, orderBy])

  const getFields = async () => {
    console.log('getFields')
    getSolListingsLastUpdated(limit, orderBy, searchField).then((list: any) => {
      setLastUpdatedList(list)
    })
    // setSearchField('')
    return
  }

  function copyToClipboard(name: string, id: string) {
    navigator.clipboard.writeText(id)
    toast(name + ' ID Copied', {
      position: 'bottom-center',
      hideProgressBar: true,
      theme: 'dark',
      autoClose: 1000,
    })
  }

  const handleChange = (e: any) => {
    e.preventDefault()
    setSearchField(e.target.value)
  }
  const onSubmit = () => {
    getFields()
  }

  return (
    <React.Fragment>
      <MainLayout style={{ backgroundColor: '#FFFFFF' }}>
        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-2xl text-center pb-4 pt-8 md:text-left lg:text-left px-6'>
            Last Updated Listings Page
          </h1>
          <div className='flex justify-between items-center pb-6 rounded-lg bg-white md:bg-transparent lg:bg-transparent'>
            <div className='flex flex-row pl-6 mr-6'>
              <input
                type='text'
                placeholder='Search here'
                onChange={handleChange}
                value={searchField}
                style={{
                  padding: 8,
                  marginRight: 6,
                  width: 200,
                  borderColor: 'gray',
                  borderWidth: 'thin',
                  borderRadius: 6,
                }}
              />
              <Button onClick={onSubmit} style={{ color: '#FFFFFF', backgroundColor: '#000000' }}>
                Search
              </Button>
            </div>

            {/** Filter by MCap or oldest last_updated_at */}
            <div className='flex flex-row pr-6'>
              <p style={{ marginRight: 12 }}>Order by:</p>
              <label style={{ marginRight: 16 }}>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='orderBy'
                  value='stats.market_cap'
                  required={true}
                  defaultChecked={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setOrderBy('stats.market_cap')
                  }}
                />
                Top market cap
              </label>

              <label>
                <input
                  type='radio'
                  className='border-2 rounded-lg p-2'
                  name='orderBy'
                  value='last_updated_at'
                  required={true}
                  style={{ marginRight: 4 }}
                  onChange={() => {
                    setOrderBy('last_updated_at')
                  }}
                />
                Oldest last updated
              </label>
            </div>
          </div>

          <table className='w-full flex flex-row flex-nowrap overflow-hidden mb-4'>
            <thead className='hidden border-b md:table-header-group lg:table-header-group'>
              <tr className='flex flex-col flex-nowrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0'>
                <th className='text-left font-bold'></th>
                <th className='text-left p-4 font-bold'>Name & Collection ID</th>
                <th className='text-left p-4 font-bold'>Last Updated Listings At</th>
                <th className='text-left p-4 font-bold'>Total Items</th>
                <th className='text-left p-4 font-bold'></th>
              </tr>
            </thead>
            <tbody className='w-full'>
              {!lastUpdatedList && <p>Loading...</p>}

              {lastUpdatedList &&
                lastUpdatedList.map((doc: any, index: number) => (
                  <tr
                    key={index}
                    className='bg-white flex flex-col flex-nowrap rounded-lg mb-2 sm:table-row sm:mb-4 md:rounded-none lg:rounded-none'
                  >
                    <td className='p-4 flex center'>
                      <Chip
                        className={
                          doc?.active == null || doc?.active
                            ? 'bg-green-100 border-green-100 text-green-800 px-4'
                            : 'bg-red-100 border-red-100 text-red-800 px-6'
                        }
                      >
                        {doc?.active == null || doc?.active ? 'Active: True' : 'Active: False'}
                      </Chip>
                    </td>
                    <td className='p-4 sm:flex-1'>
                      <p className='text-left font-bold md:hidden lg:hidden py-2'>
                        Name & Collection ID
                      </p>
                      <div className='flex flex-col lg:items-center lg:flex-row lg:space-x-2'>
                        <div className='flex shrink-0'>
                          <img src={doc?.image_url} width={50} />
                        </div>
                        <div className='flex-1 truncate'>
                          <p style={{ maxWidth: 200 }}>{doc?.name}</p>
                          <div className='flex flex-row'>
                            <p className='text-sm' style={{ color: 'grey', fontSize: 12 }}>
                              {doc?.id ? doc?.id : 'N/A'}
                            </p>
                            <button
                              onClick={() => copyToClipboard(doc?.name, doc?.id)}
                              style={{ fontSize: 12, color: 'grey', marginLeft: 8, padding: 0 }}
                            >
                              Copy
                            </button>
                          </div>
                        </div>

                        {/* <div className='flex flex-row'>
                    <p style={{ fontSize: 12, color: 'grey' }}>{doc?.id}</p>
                    <button
                      onClick={() => copyToClipboard(doc?.id)}
                      style={{ fontSize: 12, color: 'grey', marginLeft: 8, padding: 0 }}
                    >
                      Copy
                    </button>
                      </div> */}
                      </div>
                    </td>
                    <td className='p-4 sm:flex-1'>
                      <p className='text-left font-bold md:hidden lg:hidden py-2'>
                        Last Updated Listings At
                      </p>
                      <div className='flex flex-col lg:items-center lg:flex-row lg:space-x-2'>
                        <div className='flex-1 truncate'>
                          <p>
                            {doc?.listings?.lastUpdatedTime
                              ? new Date(doc?.listings?.lastUpdatedTime * 1000).toLocaleTimeString(
                                  'en-US',
                                  {
                                    // en-US can be set to 'default' to use user's browser settings
                                    month: 'short',
                                    day: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                  },
                                )
                              : 'N/A'}
                          </p>
                        </div>
                      </div>
                    </td>

                    <td className='p-3 sm:flex-1' style={{ maxWidth: 400, flexWrap: 'wrap' }}>
                      <p className='text-left font-bold md:hidden lg:hidden py-2'>Total Items</p>
                      <div className='truncate' style={{ flexWrap: 'wrap' }}>
                        <p>{doc?.listings?.totalItems ? doc?.listings?.totalItems : 'N/A'}</p>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div className='flex justify-center pb-6 rounded-lg bg-white md:bg-transparent lg:bg-transparent'>
            <button
              className='text-blue-700 underline underline-offset-2'
              onClick={() => {
                setLimit(limit + 10)
                getFields()
              }}
            >
              Load More Collections
            </button>
          </div>
        </div>
        <ToastContainer limit={1} autoClose={3000} />
      </MainLayout>
    </React.Fragment>
  )
}

export default LastUpdatedListingsPage
